/**
 * connection selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

interface State {
    connection: {
        isOnline: boolean;
    };
}

const selectConnection = (state: State): any => state.connection;

const selectIsOnline = createDeepEqualSelector(
    selectConnection,
    connectionState => connectionState.isOnline
);

export { selectConnection, selectIsOnline };
